(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width: 768px)');
  const positions = new Map();
  const arrange = () => {
    for (const [block, anchor] of positions) {
      if (!block.isConnected) {
        anchor.remove();
        positions.delete(block);
      }
    }
    document.querySelectorAll('.product-main .product').forEach((product) => {
      const description = product.querySelector('.ph-description-panel');
      if (!description) return;
      let preceding = description;
      product.querySelectorAll('.ph-product-complementary').forEach((block) => {
        if (mobile.matches) {
          if (!positions.has(block)) {
            const anchor = document.createTextNode('');
            block.before(anchor);
            positions.set(block, anchor);
          }
          preceding.after(block);
          preceding = block;
        } else if (positions.has(block)) {
          const anchor = positions.get(block);
          anchor.after(block);
          anchor.remove();
          positions.delete(block);
        }
      });
    });
  };
  mobile.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrange, { once: true });
  } else {
    arrange();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
